import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Checkbox } from '@atlaskit/checkbox';
import { FormValues } from '../../../types/ChampionApplicationFormTypes';

const PRIVACY_POLICY_URL = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const NDA_URL =
  'https://atlassian--uat.sandbox.my.site.com/atlassianchampions/resource/1743746183000/ChampionsNDA';

type FieldErrors = {
  agreePrivacy?: string;
  agreeNda?: string;
};

type Props = {
  values: FormValues;
  updateField: <K extends keyof FormValues>(key: K, value: FormValues[K]) => void;
  errors?: FieldErrors;
};

export const AgreementsSection: React.FC<Props> = ({ values, updateField, errors }) => {
  return (
    <fieldset css={sectionBoxStyles}>
      <legend css={legendLabelStyles}>Agreements</legend>

      <div css={controlTopStyles}>
        <div css={agreementRowStyles}>
          <Checkbox
            name="agree_privacy"
            label="I agree that my personal data may be used in accordance with Atlassian\u2019s Privacy Policy."
            isChecked={values.agreePrivacy}
            onChange={() => updateField('agreePrivacy', !values.agreePrivacy)}
          />
          <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" css={linkStyles}>
            View Privacy Policy
          </a>
        </div>

        <div css={agreementRowTopStyles}>
          <Checkbox
            name="agree_nda"
            label="I agree to keep confidential any non-public information I receive as part of the Atlassian Champions program."
            isChecked={values.agreeNda}
            onChange={() => updateField('agreeNda', !values.agreeNda)}
          />
          <a href={NDA_URL} target="_blank" rel="noopener noreferrer" css={linkStyles}>
            View Non-Disclosure Agreement (NDA)
          </a>
        </div>
      </div>

      {(errors?.agreePrivacy || errors?.agreeNda) && (
        <div css={errorStyles}>
          {errors.agreePrivacy || errors.agreeNda}
        </div>
      )}
    </fieldset>
  );
};

const sectionBoxStyles = css({
  border: `1px solid ${token('color.border')}`,
  borderRadius: '4px',
  padding: token('space.300'),
  marginBottom: token('space.400'),
  backgroundColor: token('elevation.surface'),
});

const legendLabelStyles = css({
  fontWeight: 600,
  fontSize: '14px',
});

const controlTopStyles = css({
  marginTop: token('space.100'),
});

const agreementRowStyles = css({
  display: 'flex',
  flexDirection: 'column',
});

const agreementRowTopStyles = css({
  display: 'flex',
  flexDirection: 'column',
  marginTop: token('space.100'),
});

const linkStyles = css({
  marginLeft: token('space.400'),
  fontSize: '14px',
});

const errorStyles = css({
  color: token('color.text.danger'),
  fontSize: '12px',
  marginTop: token('space.050'),
});
